// src/components/faq/FAQ.js
import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  // State to track which FAQ items are open
  const [openItems, setOpenItems] = useState({
    0: true // Set the first item to be open initially
  });

  // Toggle FAQ item open/closed state
  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // FAQ data
  const faqItems = [
    {
      question: "生活保護を申請したいのですが、どこに相談すればいいですか？",
      answer: "まずは公式LINE、またはお電話からお問い合わせください。専門のスタッフがあなたの状況をヒアリングし、生活保護の申請が可能かどうかアドバイスいたします。相談はすべて0円なので、安心してご相談ください。"
    },
    {
      question: "以前、生活保護の申請を断られたことがあるのですが、再申請できますか？",
      answer: "はい、可能です。過去に断られた理由を確認し、適切な申請方法をご案内します。受給率99%の専門サポートがあるので、諦めずにまずはご相談ください。"
    },
    {
      question: "申請したことを家族や知人に知られたくないのですが、大丈夫ですか？",
      answer: "相談内容は厳重に管理し、個人情報は第三者に一切開示いたしません。また、役所とのやりとりも慎重に進めますので、安心してご相談ください。"
    },
    {
      question: "現在、生活保護を受けていますが、乗り換えはできますか？",
      answer: "現在の支援内容に不満がある方、適切なサポートを受けられていないと感じる方は、ほごらんどに乗り換えが可能です。「今の支援に不安がある」「もっと安心できる環境に移りたい」という方は、お気軽にご相談ください。"
    },
    {
      question: "住む場所がないのですが、今すぐ入居できる物件はありますか？",
      answer: "ほごらんどでは最短即日で入居できる物件をご用意しております。さらに、家電・家具付きの物件もあるため、何も持っていなくても安心して新生活を始められます。"
    },
    {
      question: "保証人がいないのですが、物件を借りることはできますか？",
      answer: "ほごらんどでは保証人なしで入居できる物件をご紹介可能ですので身寄りのない方や保証人が用意できない方でもご入居可能です。"
    },
    {
      question: "初期費用がまったくないのですが、部屋を借りられますか？",
      answer: "はい、可能です。敷金・礼金・仲介手数料すべて0円で入居できる物件をご案内します。所持金がゼロの方でも、新生活をスタートできるようサポートいたします。"
    }
  ];

  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* Frame 48098437 */}
        <div className="frame-48098437">
          {/* ttl - Title component */}
          <div className="ttl">
            <h2 className="faq-title">よくある質問</h2>
          </div>
          
          {/* qa-list - List of Q&A items */}
          <div className="qa-list">
            {faqItems.map((item, index) => (
              <div className="qa-item" key={index}>
                {/* Q area */}
                <div 
                  className="q-area" 
                  onClick={() => toggleItem(index)}
                >
                  {/* Frame 48098436 */}
                  <div className="frame-48098436">
                    {/* Frame 48098435 - Question text */}
                    <div className="frame-48098435">
                      <div className="q-letter">Q</div>
                      <div className="question-text">{item.question}</div>
                    </div>
                    
                    {/* Group 48098439 - Toggle icon (plus/minus) */}
                    <div className={`toggle-icon ${openItems[index] ? 'open' : ''}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <line x1="25" y1="12.5" x2="0" y2="12.5" stroke="white" strokeWidth="3"/>
                        {!openItems[index] && <line x1="12.5" y1="0" x2="12.5" y2="25" stroke="white" strokeWidth="3"/>}
                      </svg>
                    </div>
                  </div>
                </div>
                
                {/* A area - Only visible when item is open */}
                {openItems[index] && (
                  <div className="a-area">
                    {/* Frame 48098436 */}
                    <div className="frame-48098436">
                      {/* Frame 48098435 - Answer text */}
                      <div className="frame-48098435">
                        <div className="a-letter">A</div>
                        <div className="answer-text">{item.answer}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;